import { useEffect } from 'react'
import {
  isAuthenticated,
  hasAnyReservationRole,
  signalAuthReady,
  scheduleTokenRefresh,
  logout,
  redirectToSignIn,
  watchSession,
} from '@/services/keycloakService'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  useEffect(() => {
    if (isAuthenticated()) {
      signalAuthReady()
      scheduleTokenRefresh()
      watchSession()
    } else {
      // Redirect to landing to pick operator / login
      redirectToSignIn()
    }
  }, [])

  if (!isAuthenticated()) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    )
  }

  if (!hasAnyReservationRole()) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-background gap-4">
        <p className="text-lg font-semibold">Access Denied</p>
        <p className="text-sm text-muted-foreground">
          Your account does not have permission to use the reservation portal.
        </p>
        <button
          className="text-sm underline text-primary"
          onClick={() => logout()}
        >
          Sign out
        </button>
      </div>
    )
  }

  return <>{children}</>
}
